/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author        Afternet <info@afternet.gr>
 * @copyright   Afternet
 * @license        http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

export default function tabsSlider(){
    if($('.js-productTabs-slider').length ){
        const swiper = new Swiper(".js-productTabs-slider", {
            slidesPerView: "auto",
            freeMode: true,
            watchOverflow: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            navigation: {
                nextEl: '.js-productTabs-slider-next',
                prevEl: '.js-productTabs-slider-prev'
            },
            scrollbar: {
                el: ".js-productTabs-slider-scrollbar",
            },
        });
    }
}